import { createRoute } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';
import { Route as RootRoute } from './__root';

const LeasingFinancovani = lazy(() =>
  import('@/modules/leasing/LeasingFinancovani').then((m) => ({ default: m.LeasingFinancovani })),
);

export const Route = createRoute({
  getParentRoute: () => RootRoute,
  path: '/leasing/$id/financovani',
  component: () => (
    <Suspense fallback={null}>
      <LeasingFinancovani />
    </Suspense>
  ),
});
